export default __webpack_public_path__ + "assets/bg_della8-d9f83b7c.jpg";